import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export function Nav() {
  const location = useLocation();
  return <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-6 md:px-12" data-id="element-163">
      <Link to="/" className="flex items-center font-serif text-2xl font-bold tracking-widest text-zinc-100 hover:text-darkroom-red transition-colors" data-id="element-164">
        Lennon{' '}
        <img src="https://cdn.magicpatterns.com/uploads/3kJBxHP1sGLmWDKHxUYJda/9590ad45-bc6f-4d12-b007-1754e4ab433b.gif" alt="C" className="mx-1 inline-block h-8 w-8 translate-y-1 object-contain mix-blend-screen" data-id="element-165" />
        ripe
      </Link>
      <div className="flex gap-8 font-mono text-xs tracking-widest text-zinc-400" data-id="element-166">
        <Link to="/" className={`transition-colors hover:text-darkroom-red ${location.pathname === '/' ? 'text-darkroom-red' : ''}`} data-id="element-167">
          HOME
        </Link>
        <Link to="/music" className={`transition-colors hover:text-darkroom-red ${location.pathname === '/music' ? 'text-darkroom-red' : ''}`} data-id="element-168">
          MUSIC
        </Link>
        <Link to="/film" className={`transition-colors hover:text-darkroom-red ${location.pathname === '/film' ? 'text-darkroom-red' : ''}`} data-id="element-169">
          FILM
        </Link>
      </div>
    </nav>;
}